import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsStepStatus, PmsStepStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsStepStatus>
    useData={usePmsStepStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
